export default __webpack_public_path__ + "static/media/hero-img.438791b0.svg";